var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Brands / facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.6402 6.70667H19.8336V2.99667C18.7716 2.88624 17.7046 2.83172 16.6369 2.83333C13.4636 2.83333 11.2936 4.77 11.2936 8.31667V11.3733H7.71191V15.5267H11.2936V26.1667H15.5869V15.5267H19.1569L19.6936 11.3733H15.5869V8.725C15.5869 7.5 15.9136 6.70667 17.6402 6.70667Z",
    fill: "#003A3C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.11df5d81774b587624a226c43c860964.svg";
export { ForwardRef as ReactComponent };